export default "__VITE_ASSET__CwC8fJpV__"